module.exports = __webpack_public_path__ + "static/contes-1-d64d459a1993c8c2c738edb1ed07932e.jpeg";